module.exports = __webpack_public_path__ + "static/media/icon_locklight.e65d9f0e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_locklight.svg
// module id = 867
// module chunks = 7